import React from 'react';

import Grid from 'front/TrackingGrid';
import { useSelector } from 'react-redux';
import { AppState, appStore } from '../../../../common/store/store';
import { fetchTrackings } from '../../../../common/store/trackings';

export const Tracker = () => {
    const from = useSelector((state: AppState) => state.admin.trackingFrom);
    const to = useSelector((state: AppState) => state.admin.trackingTo);
    const [dateFilter, setDateFilter] = React.useState({ from, to });

    //const [filter, setFilter] = React.useState<(p: Tracking) => boolean>((_p: Tracking) => { return true; });



    React.useEffect(() => {
        setDateFilter({ from, to });
    }, [from, to]);

    React.useEffect(() => {
        appStore.dispatch(fetchTrackings(dateFilter));
    }, [dateFilter]);

    return <Grid></Grid>;
};
